
<info>
    <header>
        Vælg dit spil
    </header>
    <content>
        <p class="header">Spil med via Betalingsservice</p>
        <p>Når du køber lodder på klasselotteriet.dk, tilmeldes dine lodder automatisk Betalingsservice.</p>
        <p>På den måde går du aldrig glip af en gevinst, og fornyelse af dit spil sker helt automatisk.</p>
        <p>Dine gevinster overføres automatisk til din bankkonto, hvorfra vi også trækker din betaling, så længe du selv ønsker det. Slut med at stå i kø – så bliver det ikke lettere.</p>

        <p class="header">Oprettelse af betalingsabonnement</p>
        <p>Du vælger selv om du vil betale for 1 måned eller 6 måneder ad gangen – men langt størstedelen af vores spillere, vælger 6 måneder.</p>

        <p class="header">Vælg 6 måneder og slip for gebyret hver måned</p>
        <p>Månedlig betaling tillægges et gebyr på 5 kr./md. pr. Betalingsservice-aftale uanset antal lodder. Vælger du at betale for 6 måneder ad gangen, sparer du herved 30 kr. halvårligt.</p>
    </content>
</info>
